module.exports = __webpack_public_path__ + "static/img/background.a0a64f21.svg";